export const FooterLogo = () => {
  return (
    <div className="tw-z-20 tw-flex tw-flex-col tw-gap-y-[1em] min440:tw-gap-y-[3em]">
      <div className="tw-flex tw-flex-col tw-gap-y-[1.25em]">
        <img
          src="/homepage/footerLogo.png"
          alt="footerLogo"
          className="tw-h-[1em] tw-w-[126px]"
        />
        <div className="tw-h-[1em] tw-w-[338px] tw-bg-transparent" />
      </div>
      <div className="tw-flex" />
    </div>
  );
};
